export class CvProtocolHandler {
    constructor({ client, onMessage, onError, onClose, onAlive, onReport }) {
    this.client = client;
    this.onMessage = onMessage;
    this.onError = onError;
    this.onClose = onClose;
    this.onAlive = onAlive;
    this.onReport = onReport;
    // Отчёт CV-модуля (report_mode="client"): приходит один раз — после all_rep
    // или в ответ на get_report. Хранится здесь, чтобы его можно было забрать
    // и после того, как он пришёл (requestReport).
    this.report = null;
    this._reportWaiters = [];
    this.dc = null;
    this.lastRepId = 0;
    this._closed = false;
    this._retryTimer = null;
    this._startTimer = null;
  }
  
  async connect(payloadData) {
    console.log("CvProtocolHandler: connect starting...");
    this.dc = this.client.createDataChannel("chat");
    this.dc.onmessage = (event) => this._handleMessage(event);

        const tag = `[CV ${this.client.id}]`;
    this.dc.onopen = () => console.log(tag, "dc open");
    this.dc.onerror = (e) => { console.warn(tag, "dc error", e); if (!this._closed && this.onError) this.onError(e); };
    this.dc.onclose = () => { console.warn(tag, "dc close, byClient =", this._closed); if (!this._closed && this.onClose) this.onClose(); };

    const tOffer0 = performance.now();
    const offer = await this.client.createOffer();
    const tOffer1 = performance.now();
    const dictSend = { ...payloadData, sdp: offer.sdp, type: offer.type };
    const cvUrl = payloadData.cvUrl || "https://dev.cv.ezspeech.app/offer";
    
    console.log("CvProtocolHandler: fetching offer...");
    let response = await fetch(cvUrl, { 
      method: "POST", 
      headers: { "Content-Type": "application/json" }, 
      body: JSON.stringify(dictSend) 
    });
    console.log("CvProtocolHandler: fetch done, status:", response.status);

    if (!response.ok) {
      const errText = await response.text();
      throw new Error(`CV Server Error: ${response.status} - ${errText.substring(0, 100)}`);
    }
    
    const text = await response.text();
    const tHttp = performance.now();
    let answer = JSON.parse(text);
    if (answer.connection === "busy") throw new Error("Сервер занят!");
    
    console.log("CvProtocolHandler: calling setRemoteAnswer...");
    await this.client.setRemoteAnswer(answer);
    this.timing = {
      iceMs: Math.round(tOffer1 - tOffer0),
      httpMs: Math.round(tHttp - tOffer1),
      sdpMs: Math.round(performance.now() - tHttp),
    };
    console.log("CvProtocolHandler: connect finished successfully!");
  }

  _handleMessage(event) {
    if (!this.dc) return;
    let data;
    try { data = JSON.parse(event.data); } catch (e) { return; }
    if (data.pong) {
      if (this.onAlive) this.onAlive();   // pong = живость сервера (для watchdog)
      if (this.dc && this.dc.readyState === 'open')
        this.dc.send(JSON.stringify({ "ping": 1 }));
      return;
    }
    if (data.exercise_report) {
      this.report = data.exercise_report;
      this._reportWaiters.splice(0).forEach((resolve) => resolve(this.report));
      if (this.onReport) this.onReport(this.report);
      return;
    }
    if (this.onMessage) this.onMessage(data);
  }

  /**
   * Отчёт CV-модуля до закрытия соединения: уже пришедший — сразу, иначе
   * просим get_report (он же останавливает упражнение) и ждём до timeoutMs.
   * null — отчёта нет (канал закрыт или сервер не ответил): сессия не виснет.
   */
  requestReport(timeoutMs = 3000) {
    if (this.report) return Promise.resolve(this.report);
    if (!this.dc || this.dc.readyState !== 'open') return Promise.resolve(null);
    return new Promise((resolve) => {
      const timer = setTimeout(() => {
        this._reportWaiters = this._reportWaiters.filter((w) => w !== done);
        resolve(null);
      }, timeoutMs);
      const done = (report) => { clearTimeout(timer); resolve(report); };
      this._reportWaiters.push(done);
      this.dc.send(JSON.stringify({ get_report: 1 }));
    });
  }

    sendStart(onSent, delayMs = 6100, attempt = 0) {
    if (this._closed) return;
    if (!this.dc || this.dc.readyState !== 'open') {
      // retry с лимитом попыток и отменой при close (раньше — вечная петля)
      if (attempt < 10) {
        this._retryTimer = setTimeout(() => this.sendStart(onSent, delayMs, attempt + 1), 1000);
      }
      return;
    }
    this.dc.send(JSON.stringify({ "firstWord": [delayMs + 200, Date.now()] }));
    // задержка вынесена в параметр: серверная логика не меняется (6100 по умолчанию),
    // но после ответа СТО сможем управлять ею из компонента
    this._startTimer = setTimeout(() => {
      if (this.dc && this.dc.readyState === 'open') {
        this.dc.send(JSON.stringify({ "start": "True" }));
        this.dc.send(JSON.stringify({ "ping": 1 }));
        if (onSent) onSent();
      }
    }, delayMs);
  }

   close() {
    this._closed = true;
    clearTimeout(this._retryTimer);
    clearTimeout(this._startTimer);
    if (this.dc) this.dc.close();
    this.dc = null;
  }
}

if (typeof window !== "undefined") {
  window.EzSpeechCv = window.EzSpeechCv || {};
  window.EzSpeechCv.CvProtocolHandler = CvProtocolHandler;
}